import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {Field, change, untouch} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import {RESOURCES as systemResources} from '../fuseSystemsResourceMap';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';
import AccessTableRow from '../components/AccessTableRow';
import {SECTIONS} from '../shared/systemLists';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from "material-ui";

/**
 * A component for adding and removing AccessTableRows
 *
 */
class AccessTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accessChoices: [],
            accessSelectValue: null
        };
        this.handleAddNewAccess = this.handleAddNewAccess.bind(this);
        this.handleRemoveAccess = this.handleRemoveAccess.bind(this);
    }

    componentWillMount() {
        if (this.props.clearAccess) {
            this.props.dispatch(change('record-form', 'sections', []));
            this.props.dispatch(change('record-form', 'systems', []));
        }
        this.determineDataSource();
    }

    determineDataSource() {
        if (this.props.listName === 'sections') {
            this.setState({
                accessChoices: SECTIONS
            });
        } else {
            if (this.props.showAdd) {
                this.fetchData();
            }
        }
    }

    // Get data for adding to Access list
    fetchData() {
        const params = {
            filter: {},
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        let resource;
        // Set parameters and URI according to Access list name
        if (this.props.listName === 'systems') {
            resource = systemResources.Systems.GET_LIST(params);
            params.sort.field = 'name';
        }

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        let choices = this.setChoiceKeys(result.data.payload);
                        this.setState({
                            accessChoices: choices
                        });
                    }
                }).catch((error) => {
                    let message = '';
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                        if (error.response.data.error_message) {
                            message = error.response.data.error_message;
                            console.log('Error: ' + message);
                        }
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    // Add unique keys for choices
    setChoiceKeys = (choices) => {
        for (let choice of choices) {
            choice.id = choice.name;
        }
        return choices;
    };

    // Create a new item based on field values
    handleAddNewAccess = (e) => {

        const selectedValue = this.props.accessSelectValue;
        if (!selectedValue) {
            return;
        }

        // Set the component list and the record
        let accessList = this.props.accessList;
        if (accessList.findIndex(s => s === selectedValue) === -1) {
            accessList.push(selectedValue);
        }

        this.setState({
            accessSelectValue: null,
        });

        this.props.onAddUpdate([this.props.listName, selectedValue.toString()]);
        this.props.dispatch(change('record-form', this.props.listName, accessList));

        // Reset the fields
        this.props.dispatch(change('record-form', 'accessSelectField', ''));
        this.props.dispatch(untouch('record-form', 'accessSelectField'));
    };

    // Handle event from item Remove icon
    handleRemoveAccess = (item) => {
        // Set the component list and the record
        let accessList = this.props.accessList;

        // Remove the item if it exists
        let updatedList = this.removeAccessItem(accessList, item);
        if (updatedList) {
            this.props.onRemoveUpdate(item);
            this.props.dispatch(change('record-form', this.props.listName, updatedList));
            this.setState({
                accessSelectValue: null,
            });
        }
    };

    // Remove an item from an array
    removeAccessItem = (array, element) => {
        return array.filter(e => e !== element);
    };

    // Create table rows of added items
    makeAccessTable = (list, showRemove, removeClickFunc) => {
        if (!list || list.length === 0) {
            return (
                <TableRow>
                    <TableRowColumn colSpan={2}>No Selections</TableRowColumn>
                    <TableRowColumn>&nbsp;</TableRowColumn>
                </TableRow>
            )
        }
        return (
            list.map((item, index) => (
                <AccessTableRow
                    key={item.toString() + index.toString()}
                    name={item.toString()}
                    showRemove={showRemove}
                    onRemoveClick={removeClickFunc}
                />
            ))
        )
    };

    // Create Section description table
    makeSectionsDetail = () => {
        return (
            SECTIONS.map((item) => (
                <TableRow key={`section-detail-${item.id}`} style={{height: 'auto'}}>
                    <TableRowColumn colSpan={2}>{item.name}</TableRowColumn>
                    <TableRowColumn>{item.id}</TableRowColumn>
                    <TableRowColumn colSpan={2} style={{whiteSpace: 'normal'}}>{item.description}</TableRowColumn>
                </TableRow>
            ))
        );
    };

    render() {
        const {
            accessAll,
            accessList,
            listName,
            name,
            optionText,
            showAdd,
            showRemove,
            singleAccess
        } = this.props;

        const styles = {
            addBlock: {padding: '8px 0 0 16px'},
            addBtn: {marginBottom: 6, verticalAlign: 'bottom'},
            block: {display: 'block'},
            fieldDescription: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                margin: '0 0 1em 0',
            },
            fieldSmall: {display: 'inline-block', maxWidth: 80},
            fieldCreate: {display: 'inline-block', maxWidth: 120, margin: '0 1em 0 0', verticalAlign: 'top'},
            icon: {height: '40px', padding: '10px', overflow: 'inherit'},
            rowHeight: {height: '40px'},
            tableCard: {display: 'block', margin: '1em 0 0 0'},
            hiddenCard: {display: 'none'},
            innerCard: {boxShadow: 'rgba(33, 33, 33, 0.12) 0px 1px 6px', marginTop: '1em'},
        };
        const displayStyle = (accessAll) ? styles.hiddenCard : styles.tableCard;

        return (
            <Card style={displayStyle}>
                <CardText>
                    {showAdd &&
                    <span style={styles.fieldDescription}>Add or Remove access to specific {name}.</span>
                    }
                    <Table selectable={false} multiSelectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn colSpan={2}>
                                    {showRemove &&
                                    <span>Access</span>
                                    }
                                    {!showRemove &&
                                    <span>Access to {name}</span>
                                    }
                                </TableHeaderColumn>
                                <TableHeaderColumn>
                                    {showRemove &&
                                    <span>Remove</span>
                                    }
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {[...this.makeAccessTable(accessList, showRemove, this.handleRemoveAccess)]}
                        </TableBody>
                    </Table>
                    {showAdd && ((!singleAccess) || (singleAccess && accessList && accessList.length === 0)) &&
                    <div style={styles.addBlock}>
                        <div>
                            <Field name="accessSelectField"
                                   component={VirtualizedSelectInput}
                                   choices={this.state.accessChoices}
                                   label={name}
                                   optionText={optionText}
                                   defaultValue={this.state.accessSelectValue}
                                   style={styles.fieldCreate}
                                   elStyle={styles.fieldCreate}
                                   allowEmpty
                                   options={{
                                       className: "half-width inline",
                                       placeholder: `${name}`,
                                   }}
                            />
                            <FlatButton
                                primary
                                label="Add"
                                icon={<ContentAdd/>}
                                onClick={(e) => this.handleAddNewAccess(e)}
                                style={styles.addBtn}
                            />
                        </div>
                    </div>
                    }
                    {listName === 'sections' &&
                    <Card style={styles.innerCard}>
                        <CardHeader
                            title="Explanation of Sections Access"
                            actAsExpander={true} showExpandableButton={true}
                        />
                        <CardText expandable={true}>
                            <ul>
                                <li>
                                    To provide unrestricted access to the CloudSent POS Administration Portal,
                                    add <em>admin</em> access. No other Section is needed for
                                    the Admin.
                                </li>
                                <li>
                                    To provide unrestricted access to CloudSent POS devices,
                                    add <em>client_all</em> access. No other Section is needed for
                                    the POS.
                                </li>
                                <li>
                                    To provide unrestricted access to the CloudSent Reports Admin,
                                    add <em>reports</em> access. No other Section is needed for
                                    Reports.
                                </li>
                                <li>
                                    Otherwise, for Admin, Client or Reports, add the desired sections to provide
                                    specific levels of access for this User.
                                </li>
                            </ul>
                            <Table selectable={false} multiSelectable={false}>
                                <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                                    <TableRow>
                                        <TableHeaderColumn colSpan={2}>Name</TableHeaderColumn>
                                        <TableHeaderColumn>ID</TableHeaderColumn>
                                        <TableHeaderColumn colSpan={2}>Description</TableHeaderColumn>
                                    </TableRow>
                                </TableHeader>
                                <TableBody displayRowCheckbox={false}>
                                    {[...this.makeSectionsDetail()]}
                                </TableBody>
                            </Table>
                        </CardText>
                    </Card>
                    }
                </CardText>
            </Card>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        const selectValue = (form.values['accessSelectField']) ? form.values['accessSelectField'].toString() : null;
        const listValue = (form.values[ownProps.listName]) ? form.values[ownProps.listName] : ownProps.accessList;
        return {
            accessList: listValue,
            accessSelectValue: selectValue,
        }
    }
    return {
        accessList: ownProps.accessList,
        accessSelectValue: null,
    }
};

AccessTable.propTypes = {
    accessAll: PropTypes.bool,
    accessList: PropTypes.array.isRequired,
    accessSelectValue: PropTypes.string,
    addField: PropTypes.bool,
    clearAccess: PropTypes.bool,
    listName: PropTypes.string.isRequired,
    onAddUpdate: PropTypes.func,
    onRemoveUpdate: PropTypes.func,
    optionText: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    showAdd: PropTypes.bool,
    showRemove: PropTypes.bool,
    singleAccess: PropTypes.bool
};

AccessTable.defaultProps = {
    accessAll: false,
    accessList: [],
    accessSelectValue: null,
    addField: true,
    clearAccess: false,
    listName: 'systems',
    name: 'Systems',
    optionText: 'name',
    showAdd: false,
    showRemove: false,
    singleAccess: false
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(AccessTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/AccessTable.js